export const getBookAnalysesData = state => state.bookAnalyses.all;
export const getBookAnalysisData = state => state.bookAnalyses.bookAnalysis;
export const bookAnalysesIsFetching = state => state.bookAnalyses.loading.all;
export const bookAnalysisIsFetching = state => state.bookAnalyses.loading.bookAnalysis;
